<template>
  <div class="constructionSchedule">
    <div class="progressPlan">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span style="font-size: 24px">施工进度计划</span>
          <div class="head-text" style="float: right; margin-top: -4px">
            <el-input
              placeholder="请输入任务名称关键词"
              class="search-input"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              style="margin-right: 80px"
            ></el-button>
            <el-button
              type="primary"
              @click="dialogVisibleOPen"
              v-if="isCreater"
              >节点管理</el-button
            >
            <el-button type="primary" @click="QhGanttChart">甘特图</el-button>
          </div>
        </div>
        <el-row>
          <el-col :span="QhGanttChartShow || orientationIsShow ? 11 : 24">
            <el-table
              ref="multipleTable"
              :data="tableData"
              tooltip-effect="dark"
              style="width: 100%"
              height="72vh"
              row-key="pldt01"
              :highlight-current-row="true"
              default-expand-all
              @selection-change="handleSelectionChange"
              :row-class-name="tableRowClassIndex"
              :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column
                property="pldt04"
                label="任务名称"
                width="300"
                fixed="left"
              >
                <template slot-scope="scope">
                  <span
                    style="color: #336699; cursor: pointer"
                    @click="seePlandrawer(scope.row)"
                    >{{ scope.row.pldt04 }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                :property="item.property"
                :label="item.label"
                v-for="(item, index) in GanttChart"
                :key="index"
                width="100"
              ></el-table-column>
              <el-table-column property="isRele" align="center" label="关联">
                <template slot-scope="scope">{{
                  scope.row.isRele == false ? "否" : "是"
                }}</template>
              </el-table-column>
              <el-table-column
                property="pldt15"
                align="center"
                label="参与模拟"
              >
                <template slot-scope="scope">{{
                  scope.row.pldt15 == 0 ? "否" : "是"
                }}</template>
              </el-table-column>
              <el-table-column
                label="操作"
                width="300"
                fixed="right"
                v-if="!QhGanttChartShow || !orientationIsShow"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    @click="GetRecordList(scope.row)"
                    >记录</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    v-if="scope.row.isShow"
                    @click="UpdataPlandrawer2(scope.row)"
                    >修改</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    plain
                    @click="orientation(scope.row)"
                    >定位</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col v-show="QhGanttChartShow" :span="13">
            <!-- <el-card class="box-card"> -->
            <div class="gantt_ot">
              <div class="gantt"></div>
            </div>
            <!-- </el-card> -->
          </el-col>
          <el-col v-show="orientationIsShow" :span="13">
            <div style="height: 100%">
              <!-- 这里放模型 -->
              <div id="modelShow" class="model"></div>
              <el-card shadow="never" class="box-card PlanInfo modelBottom">
                <span style="font-size: 18px; color: #009dd9">模型关联</span>
                <el-button
                  size="small"
                  type="primary"
                  @click="modelChooseList"
                  style="float: right; margin-left: 10px"
                  >模型关联</el-button
                >
                <el-button
                  size="small"
                  type="primary"
                  @click="modelClose"
                  style="float: right; margin-left: 20px"
                  >模型关闭</el-button
                >
                <el-table
                  :data="modelSelectList"
                  style="width: 100%; margin-top: 20px"
                  :show-header="false"
                  border
                >
                  <el-table-column type="index"></el-table-column>
                  <el-table-column prop="mosl02"></el-table-column>
                  <el-table-column prop="user02"></el-table-column>
                  <el-table-column prop="user04"></el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <el-button
                        size="small"
                        plain
                        type="primary"
                        @click="modelView(scope.row)"
                        >预览</el-button
                      >
                      <el-button
                        size="small"
                        plain
                        type="danger"
                        @click="delectModelSelect2(scope.row)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </el-card>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
    <!-- 查看 -->
    <el-drawer title="任务信息" :with-header="false" :visible.sync="drawer">
      <el-card class="box-card PlanInfo">
        <span style="font-size: 24px; color: #009dd9">基本信息</span>
        <el-form ref="form" :model="form" label-width="120px">
          <el-form-item label="任务名称">
            <el-input v-model="form.pldt04" disabled></el-input>
          </el-form-item>
          <el-form-item label="编码">
            <el-input v-model="form.pldt16" disabled></el-input>
          </el-form-item>
          <el-form-item label="责任人">
            <el-input v-model="form.pldt12Name" disabled></el-input>
          </el-form-item>
          <el-form-item label="相关人">
            <el-input v-model="form.pldt13Name" disabled></el-input>
          </el-form-item>
          <el-form-item label="责任组织">
            <el-input v-model="form.pldt19" disabled></el-input>
          </el-form-item>
          <el-form-item label="重要程度">
            <el-input style v-model="form.pldt17" disabled></el-input>
          </el-form-item>
          <el-form-item label="紧急程度">
            <el-input style v-model="form.pldt18" disabled></el-input>
          </el-form-item>
          <el-form-item label="相对占比">
            <el-input v-model="form.pldt05" disabled></el-input>
          </el-form-item>
          <el-form-item label="任务备注">
            <el-input v-model="form.pldt24" disabled></el-input>
          </el-form-item>
          <el-form-item label="任务积分">
            <el-input v-model="form.pldt14" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card PlanInfo">
        <span style="font-size: 20px; color: #009dd9">工期信息</span>
        <el-form
          style="margin-top: 10px; font-size: 12px"
          :model="form"
          label-width="100px"
        >
          <el-form-item label="计划工期天数" label-width="100px">
            <el-input v-model="form.planDays" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划开始">
            <el-input v-model="form.pldt06N" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划完成">
            <el-input v-model="form.pldt07N" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际工期天数">
            <el-input v-model="form.trueDays" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际开始">
            <el-input v-model="form.pldt08N" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际完成">
            <el-input v-model="form.pldt09N" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card class="box-card PlanInfo">
        <span style="font-size: 24px; color: #009dd9">模型关联</span>
        <el-table
          :data="modelSelectList"
          style="width: 100%"
          :show-header="false"
          border
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="mosl02"></el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span style="color: red">预览</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card shadow="never" class="box-card PlanInfo">
        <span style="font-size: 24px; color: #009dd9">关联资料</span>
        <el-table
          :data="DataList"
          style="width: 100%"
          :show-header="false"
          border
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="prfl02"></el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <span style="color: red">预览</span>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card shadow="never" class="box-card PlanInfo">
        <span style="font-size: 24px; color: #009dd9">工程量信息</span>
        <el-row>
          <el-col :span="12">计划工程量：{{ form.pldt10 }}</el-col>
          <el-col :span="12">实际工程量：{{ form.pldt11 }}</el-col>
        </el-row>
        <p>工程量计量单位 {{ form.pldt23 }}</p>
        <p>
          完成进度：{{ CompletionSchedule }} %（父级为自动获取，子级为手动刷新）
        </p>
      </el-card>
      <el-card
        v-for="(item, index) in jinduplanList"
        :key="index"
        class="box-card PlanInfo"
      >
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="完成进度">
            <el-input v-model="item.dtlk08" disabled></el-input>
          </el-form-item>
          <el-form-item label="日期">
            <el-input v-model="item.dtlk10" disabled></el-input>
          </el-form-item>
          <div v-html="item.dtlk07"></div>
        </el-form>
      </el-card>
    </el-drawer>
    <!-- 修改 -->
    <el-drawer
      style="font-size: 22px"
      title="任务信息"
      size="35%"
      :visible.sync="drawer2"
      :before-close="handleClose"
    >
      <el-card class="box-card PlanInfo">
        <span style="font-size: 18px; color: #009dd9">基本信息</span>
        <el-button
          size="small"
          @click="updataPlan"
          type="primary"
          style="float: right"
          >修改</el-button
        >
        <el-form
          ref="form"
          :model="form"
          style="font-size: 12px; margin-top: 10px"
          label-width="100px"
        >
          <el-form-item label="任务名称">
            <el-input v-model="form.pldt04"></el-input>
          </el-form-item>
          <el-form-item label="编码">
            <el-input v-model="form.pldt16"></el-input>
          </el-form-item>
          <el-form-item label="责任人">
            <el-select
              filterable
              clearable
              style="width: 100%"
              v-model="form.pldt12Arr"
              placeholder="请选择"
              @change="AddPlanUser"
              multiple
            >
              <el-option
                v-for="item in userlist1"
                :key="item.user01"
                :label="item.user04"
                :value="item.user01"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="相关人">
            <el-select
              filterable
              clearable
              multiple
              style="width: 100%"
              v-model="form.pldt13Arr"
              placeholder="请选择"
              @change="addxg"
            >
              <el-option
                v-for="item in userlist2"
                :key="item.user01"
                :label="item.user04"
                :value="item.user01"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="责任组织">
            <el-input v-model="form.pldt19"></el-input>
          </el-form-item>
          <el-form-item label="重要程度">
            <el-rate style="margin-top: 10px" v-model="form.pldt17"></el-rate>
          </el-form-item>
          <el-form-item label="紧急程度">
            <el-rate v-model="form.pldt18"></el-rate>
          </el-form-item>
          <el-form-item label="相对占比">
            <el-input v-model="form.pldt05" disabled></el-input>
          </el-form-item>
          <el-form-item label="任务备注">
            <el-input v-model="form.pldt24"></el-input>
          </el-form-item>
          <el-form-item label="任务积分">
            <el-input v-model.number="form.pldt14"></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card shadow="never" class="box-card PlanInfo">
        <span style="font-size: 18px; color: #009dd9">工期信息</span>
        <el-form
          ref="form"
          style="margin-top: 10px; font-size: 12px"
          :model="form"
          label-width="100px"
        >
          <el-form-item label="计划工期天数">
            <el-input v-model="form.planDays" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划开始">
            <el-input v-model="form.pldt06N" disabled></el-input>
          </el-form-item>
          <el-form-item label="计划完成">
            <el-input v-model="form.pldt07N" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际工期天数">
            <el-input v-model="form.trueDays" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际开始">
            <el-input v-model="form.pldt08N" disabled></el-input>
          </el-form-item>
          <el-form-item label="实际完成">
            <el-input v-model="form.pldt09N" disabled></el-input>
          </el-form-item>
        </el-form>
      </el-card>
      <el-card shadow="never" class="box-card PlanInfo">
        <span style="font-size: 18px; color: #009dd9">模型关联</span>
        <el-button
          size="small"
          type="primary"
          @click="modelChooseList"
          style="float: right"
          >模型关联</el-button
        >
        <el-table
          :data="modelSelectList"
          style="width: 100%; margin-top: 20px"
          :show-header="false"
          border
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="mosl02"></el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button
                size="small"
                plain
                type="danger"
                @click="delectModelSelect(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <span style="display: block; font-size: 12px; margin: 20px; color: red">
        是否参与模拟：
        <el-switch
          v-model="form.pldt15"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </span>
      <el-card shadow="never" class="box-card PlanInfo">
        <span style="font-size: 18px; color: #009dd9">关联资料</span>
        <el-button
          size="small"
          type="primary"
          @click="associatedDataOpen"
          style="float: right"
          >关联资料</el-button
        >
        <el-table
          :data="DataList"
          style="width: 100%; margin-top: 20px"
          :show-header="false"
          border
        >
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="prfl02">
            <template slot-scope="scope">
              <a
                v-if="
                  exts.indexOf(
                    scope.row.prfl04.substr(
                      scope.row.prfl04.lastIndexOf('.') + 1
                    )
                  ) > -1
                "
                target="_blank"
                @click="documentOpen(scope.row)"
              >
                <el-button style="width: 100%" :title="scope.row.prfl02">{{
                  scope.row.prfl02.length > 10
                    ? scope.row.prfl02.substr(0, 10) + "..."
                    : scope.row.prfl02
                }}</el-button>
              </a>
              <span v-else>{{ scope.row.prfl02 }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-button
                size="small"
                plain
                type="primary"
                style="cursor: pointer"
                @click="download(scope.row)"
                >下载</el-button
              >
              <el-button
                size="small"
                plain
                type="danger"
                @click="delectModelSelect(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card shadow="never" class="box-card PlanInfo">
        <span style="font-size: 18px; color: #009dd9">工程量信息</span>
        <el-row style="margin-top: 10px; font-size: 14px">
          <el-col :span="12">
            计划工程量：
            <el-input style="width: 100px" v-model="form.pldt10"></el-input>
          </el-col>
          <el-col :span="12">
            实际工程量：
            <el-input style="width: 100px" v-model="form.pldt11"></el-input>
          </el-col>
        </el-row>
        <p style="margin: 20px 0; font-size: 14px">
          工程量计量单位:
          <el-input style="width: 100px" v-model="form.pldt23"></el-input>
        </p>
        <p v-if="IsWrite" style="margin-top: 10px; font-size: 14px">
          完成进度：<el-button type="primary" @click="addRecordShow"
            >设置</el-button
          >
          <!-- % （父级为自动获取，子级为手动刷新） -->
        </p>
      </el-card>
      <el-card
        v-for="(item, index) in jinduplanList"
        :key="index"
        class="box-card PlanInfo"
      >
        <el-popconfirm
          confirm-button-text="好的"
          cancel-button-text="不用了"
          icon="el-icon-info"
          icon-color="red"
          v-if="item.dtlk09 == $store.state.uid"
          @confirm="DelRecord(item.dtlk01)"
          title="确定删除吗？"
        >
          <i
            slot="reference"
            style="color: red; float: right"
            class="el-icon-delete-solid"
          ></i>
        </el-popconfirm>

        <el-form :inline="true" class="demo-form-inline">
          <el-form-item label="完成进度">
            <el-input v-model="item.dtlk08" disabled></el-input>
          </el-form-item>
          <el-form-item label="日期">
            <el-input v-model="item.dtlk10" disabled></el-input>
          </el-form-item>
          <div v-html="item.dtlk07"></div>
        </el-form>
      </el-card>
    </el-drawer>
    <!-- 插入节点 -->
    <el-dialog
      :close-on-click-modal="false"
      title="节点管理"
      :visible.sync="dialogVisibleDom"
      width="100%"
      top="0%"
    >
      <el-card class="box-card PlanInfo" style="maring-bottom: 30px">
        <el-button @click="addDom" type="primary">添加节点</el-button>
        <el-button @click="batchAddDom" type="primary">导入节点</el-button>
        <el-button @click="updateDom()" type="primary">更新</el-button>

        <template v-for="(item, index) in DomList">
          <el-row
            :key="item.id"
            v-if="item.itemIsShow"
            :style="{ width: '1800px', marginLeft: `${item.tierNum * 30}px` }"
          >
            <el-col :span="5">
              <span>名称：</span>
              <el-input v-model="item.pldt04"></el-input>
            </el-col>
            <el-col :span="8">
              <el-date-picker
                v-model="item.timeArr"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                :clearable="false"
                end-placeholder="结束日期"
                format="yyyy/MM/dd"
                value-format="yyyy/MM/dd"
                @change="
                  (data) => {
                    pickerChange(data, item);
                  }
                "
              ></el-date-picker>
            </el-col>
            <el-col :span="4">
              <span>任务占比：</span>
              <el-input v-model="item.pldt05" style="width: 35%"></el-input>
            </el-col>
            <el-col :span="1">
              <el-button
                type="danger"
                size="small"
                @click="deleteDom(index, item)"
                >删除</el-button
              >
            </el-col>
            <el-col :span="1">
              <el-button
                type="danger"
                size="small"
                @click="addChildDom(index, item)"
                >添加</el-button
              >
            </el-col>
            <!-- <el-col :span="1">
              <el-button type="danger" size="small" @click="itemMove(index,item,'up')">上移</el-button>
            </el-col>
            <el-col :span="1">
              <el-button type="danger" size="small" @click="itemMove(index,item,'down')">下移</el-button>
            </el-col>-->
          </el-row>
        </template>
      </el-card>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      title="关联资料"
      :visible.sync="associatedData"
      width="80%"
      center
    >
      <el-row>
        <el-col
          :span="4"
          v-for="(item, index) in GetFilesLinksList2"
          :key="index"
        >
          <div style="border: 1px dotted; border-radius: 10px; margin: 0 3px">
            <el-row>
              <el-col :span="16"
                ><span style="line-height: 27px">{{
                  item.prfl02
                }}</span></el-col
              >
              <el-col :span="4">
                <el-button
                  size="small"
                  @click="deleteGetFilesLinksList2Item(index)"
                  >x</el-button
                >
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <el-container>
        <el-aside width="200px">
          <el-button type="primary" size="small" @click="showAll"
            >显示全部文件</el-button
          >
          <div class="zTreeDiv">
            <ul id="ProjectFileTree" class="ztree"></ul>
          </div>
          <div
            id="dataListRemenu"
            v-if="
              ($store.state.permissions != null &&
                $store.state.permissions.includes('701')) ||
              $store.state.isProject
            "
          >
            <ul>
              <li id="addDataList">新增资料</li>
            </ul>
          </div>
        </el-aside>
        <el-main>
          <div class="head-text" style="float: right; margin-top: -4px">
            <!-- 新建事件 -->
            <el-input
              placeholder="请输入关键字"
              style="width: 200px"
              class="search-input"
              v-model="query3"
            ></el-input>
            <el-button
              slot="append"
              icon="el-icon-search"
              style="margin-right: 80px"
            ></el-button>
          </div>
          <el-table
            ref="multipleTable"
            :data="GetFilesLinksList"
            height="500"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange2"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="prfl02" label="名字"></el-table-column>
          </el-table>
          <el-row>
            <el-col :span="3" :offset="8">
              <el-button type="success" @click="AddassociatedData"
                >确定关联</el-button
              >
            </el-col>
            <el-col :span="3">
              <el-button type="danger" @click="associatedDataClose"
                >取消</el-button
              >
            </el-col>
          </el-row>
        </el-main>
      </el-container>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="模型选择集"
      :visible.sync="modelChooseListOpen"
      width="40%"
      center
    >
      <el-row style="display: flex; align-items: center">
        <el-col :span="17">
          <el-input
            placeholder="请输入关键字进行搜索"
            v-model="query2"
          ></el-input>
        </el-col>
        <el-col :span="4" :offset="1">
          <el-button size="small" type="primary" @click="aa"
            >查找</el-button
          ></el-col
        >
      </el-row>
      <el-table
        ref="multipleTable"
        :data="GetModelSelectList"
        tooltip-effect="dark"
        style="width: 100%"
        height="500px"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="mosl02" label="选择集名称"></el-table-column>
        <el-table-column prop="user02" label="创建者账号"></el-table-column>
        <el-table-column prop="user04" label="创建者名字"></el-table-column>
      </el-table>
      <el-row>
        <el-col :span="3" :offset="9">
          <el-button type="success" @click="AddmodelChooseListOpen"
            >确定</el-button
          >
        </el-col>
        <el-col :span="3">
          <el-button type="danger" @click="modelChooseListClose"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="进度记录"
      :visible.sync="planjindu"
      width="40%"
      top="5%"
      center
    >
      <div style="height: 700px; overflow: auto">
        <el-card
          v-for="(item, index) in jinduplanList"
          :key="index"
          class="box-card PlanInfo"
        >
          <el-popconfirm
            confirm-button-text="好的"
            cancel-button-text="不用了"
            icon="el-icon-info"
            icon-color="red"
            v-if="item.dtlk09 == $store.state.uid"
            @confirm="DelRecord(item.dtlk01)"
            title="确定删除吗？"
          >
            <i
              slot="reference"
              style="color: red; float: right"
              class="el-icon-delete-solid"
            ></i>
          </el-popconfirm>

          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="完成进度">
              <el-input v-model="item.dtlk08" disabled></el-input>
            </el-form-item>
            <el-form-item label="日期">
              <el-input
                v-model="item.dtlk10"
                disabled
                style="width: 200px"
              ></el-input>
            </el-form-item>
            <div v-html="item.dtlk07"></div>
          </el-form>
        </el-card>
      </div>
    </el-dialog>
    <!-- 批量文件添加节点 -->
    <el-dialog
      :close-on-click-modal="false"
      title="导入节点"
      :visible.sync="batchAddFile"
      width="40%"
      center
    >
      <p>
        点击下载模板文件：
        <a
          style="color: red"
          :href="$store.state.baseUrl + '/UploadFiles/进度计划示例表格.xlsx'"
          target="_blank"
          >示例表格.XLSX</a
        >并按要求填好后上传
      </p>
      <!-- <p>"注意：选项均不能为空，计划开始时间小于等于计划开始时间，时间格式：2020-02-21 14:00任务占比总和必须为100
      请按照上述要求填写，否则会导致上传失败！</p>-->
      <el-upload
        ref="upload"
        class="upload-demo"
        :action="actionUrl"
        :on-change="handleChange"
        :file-list="fileList"
        :limit="1"
        :data="nodeFileData"
        :before-upload="beforeUpload"
        accept=".xlsx"
        :auto-upload="false"
        :on-success="uploadSuccess"
        :headers="importHeaders"
        :on-exceed="handleExceed"
        :on-error="uploadError"
      >
        <el-button slot="trigger" size="small" type="primary"
          >选择文件</el-button
        >
        <el-button
          style="margin-left: 10px"
          size="small"
          type="success"
          @click="submitUpload"
          >上传到服务器</el-button
        >
        <div slot="tip" class="el-upload__tip">只能上传xlsx文件</div>
      </el-upload>
    </el-dialog>
    <!-- 新增 -->
    <el-dialog
      :close-on-click-modal="false"
      title="新增资料"
      :visible.sync="dialogVisible"
      width="40%"
    >
      <el-row>
        <el-col :span="12">
          <el-upload
            class="upload-demo"
            ref="upload2"
            :action="actionUrl2"
            :before-upload="handleBefore2"
            :file-list="fileList2"
            :auto-upload="false"
            :data="aaa"
            :headers="importHeaders"
            :on-success="handleSuccess2"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
          </el-upload>
        </el-col>
        <el-col :span="12">
          可见设置：
          <el-radio v-model="radio" :label="1">公开</el-radio>
          <el-radio v-model="radio" :label="2">半公开</el-radio>
          <div
            style="
              border: 2px solid #eee;
              height: 200px;
              max-height: 200px;
              overflow: auto;
              width: 80%;
              box-sizing: border-box;
            "
            v-if="radio == 2"
          >
            <el-row style="padding: 10px">
              <el-col
                :span="8"
                v-for="(item, index) in multipleSelection3"
                :key="index"
                style="padding-top: 10px"
              >
                <el-row style="padding: 0px">
                  <el-col :span="20">{{ item.user04 }}</el-col>
                  <el-col :span="4">
                    <span
                      style="color: red; cursor: pointer"
                      @click="delectUser(index)"
                      >x</span
                    >
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-button
            type="primary"
            size="small"
            style="margin: 10px"
            v-if="radio == 2"
            @click="dialogVisible1OPen"
            >添加</el-button
          >
        </el-col>
      </el-row>
      <el-row style="height: 80px">
        <el-col :span="3" :offset="8">
          <el-button type="primary" style="width: 100%" @click="submitUpload2"
            >上传</el-button
          >
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button
            type="primary"
            style="width: 100%"
            @click="dialogVisibleDom = false"
            >取消</el-button
          >
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 项目下的人员列表 -->
    <el-dialog
      :close-on-click-modal="false"
      title="请选择人员"
      :visible.sync="dialogVisible1"
      width="25%"
    >
      <div class="head-text">
        <!-- 新建事件 -->
        <el-input
          v-model="selectName"
          placeholder="请输入名称"
          class="search-input"
          style="width: 80%"
        ></el-input>
        <el-button
          @click="dialogVisible1OPen"
          slot="append"
          icon="el-icon-search"
        ></el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="tableData3"
        tooltip-effect="dark"
        style="width: 100%"
        max-height="400"
        @selection-change="handleSelectionChange3"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column prop="user02" label="帐号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <div
        style="width: 100%; height: 40px; margin-top: 10px; text-align: center"
      >
        <el-button type="primary" size="small" @click="dialogVisible1 = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 设置完成进度 -->
    <el-dialog
      :close-on-click-modal="false"
      title="完成进度"
      :visible.sync="addRecordIsShow"
      width="30%"
    >
      <el-form>
        <el-form-item label="进度">
          <el-input
            style="width: 80%"
            v-model.number="Record"
            placeholder="（父级为自动获取，子级为手动刷新）"
          ></el-input>
        </el-form-item>
        <el-form-item label="时间">
          <el-date-picker
            style="width: 80%"
            v-model="RecordTime"
            type="datetime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>

        <ckediter4 ref="ck" v-model="recordDetial"></ckediter4>
      </el-form>
      <el-button type="primary" size="small" @click="AddRecord">确定</el-button>
    </el-dialog>

    <!-- 资料预览 -->
    <el-dialog
      :close-on-click-modal="false"
      title="资料预览"
      width="40%"
      :visible.sync="documentIsShow"
    >
      <div>
        <iframe
          width="100%"
          height="500px"
          :src="iframeUrl"
          frameborder="0"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetPlanNode,
  GetPlanDetailTree,
  UpdatePlanNode,
  GetPlanDetailOne,
  UpdatePlanDetail,
  GetModelSelect,
  GetProjectFileZTree,
  GetFilesLinks,
  AddPlanSelectOrDocument,
  DelPlanSelectOrDocument,
  AddRecord,
  GetRecordList,
  insertExcelPlanNode,
  GetModelInfos,
  GetFileWhitOutUserList,
  GetDeptUser,
  AddPlanUser,
  DelRecord,
  Office2Pdf,
  GetPlanOne,
} from "@/setAxios";

import ckediter4 from "@/components/ck.vue";
import * as tools from "@/tools/tool";
export default {
  components: { ckediter4 },
  name: "constructionSchedule",
  data() {
    return {
      CompletionSchedule: 0,
      documentIsShow: false,
      recordDetial: "",
      addRecordIsShow: false,
      // 定位功能显示
      orientationIsShow: false,
      actionUrl: this.$store.state.baseUrl + "/api/insertExcelPlanNode",
      actionUrl2: this.$store.state.baseUrl + "/api/UploadDataFile",
      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      fileList2: [],
      nodeFileData: {
        gsid: localStorage.getItem("pid"),
        xid: localStorage.getItem("xid"),
        planid: "",
        uid: localStorage.getItem("id"),
      },
      batchAddFile: false,
      jinduplanList: [],
      aaa: {
        uid: localStorage.getItem("id"),
        Uids: "",
        xid: localStorage.getItem("xid"),
        type: 1,
        gid: 0,
        qid: localStorage.getItem("pid"),
      },
      radio: "",
      multipleSelection3: [],
      dialogVisible1: false,
      selectName: "",
      tableData3: [],
      GanttChart: [
        { property: "State", label: "状态" },
        { property: "ExtensionDays", label: "延期天数" },
        { property: "CompletionSchedule", label: "完成进度" },
        { property: "PlanDays", label: "计划工期天数" },
        { property: "pldt05", label: "计划占比" },
        { property: "pldt06", label: "计划开始" },
        { property: "pldt07", label: "计划结束" },
        { property: "RealDays", label: "实际工期天数" },
        { property: "pldt08", label: "实际开始" },
        { property: "pldt09", label: "实际完成" },
        { property: "pldt10", label: "计划工程量" },
        { property: "pldt11", label: "实际工程量" },
        { property: "pldt23", label: "计量单位" },
        { property: "pldt12Name", label: "责任人" },
        { property: "pldt13Name", label: "相关人" },
      ],
      Record: "",
      RecordTime: "",
      modelSelectList: [],
      DataList: [],
      ModelList: [],
      GetModelSelectList: [],
      modelName: "",
      query2: "",
      TreeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      GetFilesLinksList2: [],
      associatedData: false,
      DomList: [],
      form: {},
      form2: {},
      drawer: false,
      drawer2: false,
      dialogVisibleDom: false,
      dialogVisible: false,
      value: "",
      tableData: [],
      multipleSelection: [],
      planid: "",
      modelId: "",
      pldt01: "",
      time: [],
      fId: 0,
      fid: 0,
      F6: "",
      F7: "",
      bol: [],
      query3: "",
      GetFilesLinksList: [],
      GetModelSelectList2: [],
      modelChooseListOpen: false,
      ruleForm: {
        FileIds: [],
      },
      IsWrite: false,
      GanttChartData: [],
      GanttChartData2: [],
      planjindu: false,
      QhGanttChartShow: false,
      modelUrl: [],
      viewer: null,
      addPldt01: 1,
      tierNum: 0,
      isCreater: false,
      userlist: [],
      userlist1: [],
      userlist2: [],
      pldt12: "",
      pldt13: "",
      exts: [
        "png",
        "jpg",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "js",
        "txt",
        "gif",
        "pdf",
      ],
      iframeUrl: "",
      tableDataLocation: [],
    };
  },
  created() {
    if (this.$route.params.pldt03) {
      this.planid = this.$route.params.pldt03;
      let params = {
        planid: this.planid,
      };
      GetPlanOne(params).then((res) => {
        this.modelId = res.Data.pjpl11;
        let userId = res.Data.pjpl07;
        this.nodeFileData.planid = this.planid;
        if (userId == this.$store.state.uid) {
          this.isCreater = true;
        }
        this.GetPlanDetailTree();
      });
    } else {
      try {
        let code = this.$route.query.code.replace(/%3D/g, "=");
        code = Base64.decode(code).split("&");
        this.planid = code[0].split("=")[1];
        this.modelId = code[1].split("=")[1];
        let userId = code[2].split("=")[1];
        this.nodeFileData.planid = this.planid;
        if (userId == this.$store.state.uid) {
          this.isCreater = true;
        }
        if (this.planid == "") {
          this.$message({
            type: "success",
            message: "请先选择进度计划",
          });
          this.$router.push({
            path: "/progressPlan",
          });
        } else {
          this.GetPlanDetailTree();
        }
      } catch {
        this.$message({
          type: "success",
          message: "请先选择进度计划",
        });
        this.$router.push({
          path: "/progressPlan",
        });
      }
    }
  },
  methods: {
    tableRowClassIndex({ row, rowIndex }) {
      if (this.$route.params) {
        let index = this.tableDataLocation.findIndex(
          (ele) => ele == this.$route.params.pldt01
        );
        if (rowIndex === index) {
          return "warning-index";
        }
        return "";
      }
    },
    async DelRecord(id) {
      let res = await DelRecord({ id });
      if (res.Code) {
        this.$message.success("删除成功");
        this.GetRecordList({ pldt01: this.pldt01 });
        this.planjindu = false;
      }
    },
    addRecordShow() {
      this.addRecordIsShow = true;
    },
    addxg(data) {
      this.$forceUpdate()
      this.pldt13 = data.join(",");
      this.form.pldt13 = data.join(",");
      UpdatePlanDetail({ model: this.form }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          let params1 = [];
          this.pldt13.split(",").forEach((ele) => {
            let params = {
              plvs02: localStorage.xid,
              plvs03: this.planid,
              plvs04: ele,
            };
            params1.push(params);
          });
          AddPlanUser(params1).then((res) => {
            this.GetPlanDetailTree();
          });
        }
      });
    },
    AddPlanUser(data) {
      this.$forceUpdate()
      this.form.pldt12 = data.join(",");
      this.pldt12 = data.join(",");
      UpdatePlanDetail({ model: this.form }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          let params1 = [];
          this.pldt13.split(",").forEach((ele) => {
            let params = {
              plvs02: localStorage.xid,
              plvs03: this.planid,
              plvs04: ele,
            };
            params1.push(params);
          });
          AddPlanUser(params1).then((res) => {
            this.GetPlanDetailTree();
          });
        }
      });
    },
    // 修改
    UpdataPlandrawer2(row) {
      this.Record = "";
      this.IsWrite = row.IsWrite;
      this.pldt01 = row.pldt01;
      this.GetPlanDetailOne();
      this.drawer2 = true;
      this.GetRecordList(row);
      this.planjindu = false;
    },
    // 获取详情
    GetPlanDetailOne() {
      let params = {
        id: this.pldt01,
      };
      GetPlanDetailOne(params).then((res) => {
        this.form = res.Data;
        this.form.pldt15 == 1
          ? (this.form.pldt15 = true)
          : (this.form.pldt15 = false);
        if (this.form.pldt12) {
          this.pldt12 = this.form.pldt12;
          this.form.pldt12Arr = res.Data.pldt12.split(",").map(Number);
        } else {
          this.pldt12 = "";
          this.form.pldt12Arr = [];
        }
        if (this.form.pldt13) {
          this.pldt13 = this.form.pldt13;
          this.form.pldt13Arr = res.Data.pldt13.split(",").map(Number);
        } else {
          this.form.pldt13Arr = [];
          this.pldt13 = "";
        }
        this.modelSelectList = res.Data.selectList;
        this.DataList = res.Data.docList;
        this.userlist1 = res.Data.pldt12List;
        this.userlist2 = res.Data.pldt13List;
        this.GetDeptUser();
      });
    },
    async GetDeptUser() {
      let params = {
        searchword: "",
        xid: this.$store.state.xid,
        bid: "null",
        cid: this.$store.state.pid,
        pageIndex: 1,
        pageSize: 99999,
      };
      let res = await GetDeptUser({ params });
      this.userlist = res.Data.list;
      if (this.userlist1) {
        if (this.userlist) {
          this.userlist1 = [...this.userlist, ...this.userlist1];
        }
      } else {
        if (this.userlist) {
          this.userlist1 = this.userlist;
        }
      }

      if (this.userlist2) {
        if (this.userlist) {
          this.userlist2 = [...this.userlist, ...this.userlist2];
        }
      } else {
        if (this.userlist) {
          this.userlist2 = this.userlist;
        }
      }
      this.userlist1 = this.userfilter(this.userlist1, "user01");
      this.userlist2 = this.userfilter(this.userlist2, "user01");
    },
    userfilter(data, val) {
      const res = new Map();
      return data.filter(
        (item) => !res.has(item[val]) && res.set(item[val], 1)
      );
    },
    // 跟新节点
    async updateDom() {
      if (!this.isPercent()) {
        this.$message({
          type: "error",
          message: "请检查填写选项",
        });
        return;
      }
      let params = {
        planid: this.planid,
        list: this.DomList,
      };
      let res = await UpdatePlanNode(params);
      if (res.Code > 0) {
        this.$message({
          type: "success",
          message: "添加成功",
        });
        this.dialogVisibleDom = false;
        this.GetPlanDetailTree();
      } else {
        this.$message({
          type: "warning",
          message: "添加失败",
        });
      }
    },
    // 判断同级百分比相加是否为100
    isPercent() {
      let isPer = true;
      this.DomList.forEach((ele) => {
        let Percent = 0;
        let newArr = this.DomList.filter((ele2) => ele2.pid == ele.pid);
        newArr.forEach((item) => {
          Percent += Number(item.pldt05);
        });
        let isPer2 = Percent != 100 ? true : false;
        if (isPer2) {
          isPer = false;
        }
      });
      if (!isPer) return isPer;
      isPer =
        this.DomList.filter((e) => e.pldt04.trim() == "").length > 0
          ? false
          : true;
      if (!isPer) return isPer;
      isPer =
        this.DomList.filter((e) => e.timeArr.length == 0).length > 0
          ? false
          : true;
      if (!isPer) return isPer;
      return isPer;
    },
    pickerChange(data, item) {
      let newObj = this.DomList.find((ele) => ele.id == item.pid);
      let childObj = this.DomList.filter((ele) => ele.pid == item.id);
      // 判断自身要比子元素的时间节点大
      childObj.forEach((ele) => {
        if (
          new Date(Date.parse(data[0])) > new Date(Date.parse(ele.pldt06)) ||
          new Date(Date.parse(data[1])) < new Date(Date.parse(ele.pldt07))
        ) {
          this.$message({
            type: "warning",
            message: "请输入正确的时间范围(父节点必须包含子节点)",
          });
          item.timeArr = [];
          item.pldt05 = null;
          this.jsZB(item);
          return false;
        }
      });
      if (newObj) {
        if (
          new Date(Date.parse(data[0])) < new Date(Date.parse(newObj.pldt06)) ||
          new Date(Date.parse(data[1])) > new Date(Date.parse(newObj.pldt07))
        ) {
          this.$message({
            type: "warning",
            message: "请输入正确的时间范围(子节点必须在父节点内)",
          });
          item.timeArr = [];
          item.pldt05 = null;
          this.jsZB(item);
          return false;
        } else {
          item.pldt06 = data[0];
          item.pldt07 = data[1];
        }
      } else {
        item.pldt06 = data[0];
        item.pldt07 = data[1];
      }
      this.jsZB(item);
    },
    //计算占比
    jsZB(item) {
      // 这里对任务占比做处理
      // 同级所有对象切时间选择过的
      let allObj = this.DomList.filter(
        (ele) => ele.pid == item.pid && ele.timeArr.length > 0
      );
      if (allObj.length === 0) {
        return false;
      }
      // 拿到同级对象的每个Index指
      let allObjIndex = new Array();
      allObj.forEach((ele) => {
        let index = this.DomList.findIndex((ele2) => ele.id == ele2.id);
        let option = {
          index,
          value: ele,
        };
        allObjIndex.push(option);
      });
      // 计算每一层的任务占比
      // 计算出同层所有时间的和
      let timeAll = 0;
      allObjIndex.forEach((ele) => {
        let timeBucket =
          new Date(Date.parse(ele.value.timeArr[1])) -
          new Date(Date.parse(ele.value.timeArr[0])) +
          86400000;
        timeAll += timeBucket;
      });
      let extra = 0;
      // 这个计算占比
      allObjIndex.forEach((ele) => {
        let timeBucket =
          new Date(Date.parse(ele.value.timeArr[1])) -
          new Date(Date.parse(ele.value.timeArr[0])) +
          86400000;
        ele.value.pldt05 = ((timeBucket / timeAll) * 100).toFixed(0);
        extra += Number(ele.value.pldt05);
      });
      //检查综合是否等于100
      if (extra - 100 != 0) {
        allObj[0].pldt05 = Number(allObj[0].pldt05) + Number(100 - extra);
      }
    },
    dialogVisibleOPen() {
      this.fId = 0;
      this.dialogVisibleDom = true;
      let params = {
        xid: localStorage.xid,
        planid: this.planid,
      };
      // test
      var maxpldt01 = 1;
      GetPlanNode(params).then((res) => {
        this.DomList = res.Data;
        this.DomList.forEach((ele, i) => {
          maxpldt01 = maxpldt01 < ele.pldt01 ? ele.pldt01 : maxpldt01;
          ele.type = "old";
          this.$set(ele, "timeArr", [ele.pldt06N, ele.pldt07N]);
          ele.id = ele.pldt01;
          ele.pid = ele.pldt22;
          ele.isPClear = false;
          // ele.isExpansionShow = false;
          ele.itemIsShow = true;
          // ele.isExpansion = false;
          ele.isUpdate = false;
          ele.pldt06 = ele.pldt06N;
          ele.pldt07 = ele.pldt07N;
        });
        this.addTierNum();
        this.itemRank();
        this.addPldt01 = maxpldt01;
      });
    },
    // 对获取的值进行排序
    itemRank() {
      this.DomList.forEach((item, index) => {
        let newArr = this.DomList.filter((ele) => ele.pid == item.id);
        let newArrLength = newArr.length;
        newArr.forEach((ele) => {
          let newIndex = this.DomList.findIndex(
            (ele2) => ele2.pldt01 == ele.pldt01
          );
          this.DomList.splice(newIndex, 1);
        });
        this.DomList.splice(index + 1, 0, ...newArr);
      });
    },
    addTierNum() {
      if (this.DomList.filter((e) => e.isUpdate == false).length > 0) {
        this.DomList.filter((e) => e.isUpdate == false).forEach((v, i) => {
          if (this.DomList[i].pid == 0) {
            this.DomList[i].tierNum = 0;
            this.DomList[i].isUpdate = true;
          } else {
            var a = this.DomList.filter(
              (ele) => ele.id == v.pid && ele.isUpdate
            );
            if (a.length > 0) {
              this.DomList[i].tierNum = a[0].tierNum + 1;
              this.DomList[i].isUpdate = true;
            }
          }
        });
      }
      if (this.DomList.filter((e) => e.isUpdate == false).length > 0) {
        this.addTierNum();
      }
    },
    addDom() {
      this.DomList.push({
        tierNum: this.tierNum,
        isExpansionShow: false,
        itemIsShow: true,
        isExpansion: false,
        timeArr: [],
        ChildMaxTime: null,
        ChildMinTime: null,
        pldt01: 0,
        id: this.addPldt01,
        pldt02: localStorage.xid,
        pldt03: this.planid,
        // 任务名称
        pldt04: "",
        // 相对占比
        pldt05: "",
        // 计划开始时间
        pldt06: "",
        // 计划结束时间
        pldt07: "",
        pldt08: "",
        pldt09: "",
        pldt10: "",
        pldt11: "",
        pldt12: "",
        pldt13: "",
        pldt14: "",
        pldt15: 1,
        pldt16: "",
        pldt17: "",
        pldt18: "",
        pldt19: "",
        pldt20: new Date(),
        pldt21: localStorage.id,
        // 父节点ID
        pldt22: 0,
        pid: 0,
        pldt23: "",
        time: [],
        type: "new",
        isPClear: true,
      });
      this.addPldt01++;
    },
    cutShow(item, index) {
      let newObj = this.DomList.find((ele) => ele.pid == item.id);
      if (newObj) {
        if (item.isExpansionShow) {
          this.conceal(item);
        } else {
          this.itemShow(item);
        }
        this.DomList[index].isExpansionShow =
          !this.DomList[index].isExpansionShow;
      } else {
        return false;
      }
    },
    // 使子元素隐藏或显示
    conceal(item) {
      // find只能取第一个，这里我们需要用filter
      let newObj = this.DomList.filter((ele) => ele.pid == item.id);
      if (newObj) {
        newObj.forEach((ele) => {
          let newIndex = this.DomList.findIndex((ele2) => ele2.id == ele.id);
          this.DomList[newIndex].itemIsShow = false;
          this.conceal(ele);
        });
      }
    },
    // 上移下移
    itemMove(index, item, type) {
      let newObj = JSON.parse(JSON.stringify(item));
      if (type == "up") {
        if (this.DomList[index].tierNum > this.DomList[index - 1].tierNum) {
          return false;
        }
        this.$set(this.DomList, index, this.DomList[index - 1]);
        this.$set(this.DomList, index - 1, newObj);
      } else {
        if (this.DomList[index].tierNum > this.DomList[index + 1].tierNum) {
          return false;
        }
        this.$set(this.DomList, index, this.DomList[index + 1]);
        this.$set(this.DomList, index + 1, newObj);
      }
    },
    itemShow(item) {
      // find只能取第一个，这里我们需要用filter
      let newObj = this.DomList.filter((ele) => ele.pid == item.id);
      if (newObj) {
        newObj.forEach((ele) => {
          let newIndex = this.DomList.findIndex((ele2) => ele2.id == ele.id);
          this.DomList[newIndex].itemIsShow = true;
          this.itemShow(ele);
        });
      }
    },
    // 添加子节点++++++++++++
    addChildDom(index, item) {
      this.DomList[index].isExpansionShow = true;
      this.getTierNum(item);
      let isPClear = false;
      if (item.type == "new") {
        isPClear = true;
      }
      this.DomList.splice(index + 1, 0, {
        tierNum: this.tierNum,
        isExpansionShow: false,
        itemIsShow: true,
        isExpansion: true,
        timeArr: [],
        ChildMaxTime: null,
        ChildMinTime: null,
        pldt01: 0,
        id: this.addPldt01,
        pldt02: localStorage.xid,
        pldt03: this.planid,
        // 任务名称
        pldt04: "",
        // 相对占比
        pldt05: "",
        // 计划开始时间
        pldt06: "",
        // 计划结束时间
        pldt07: "",
        pldt08: "",
        pldt09: "",
        pldt10: "",
        pldt11: "",
        pldt12: "",
        pldt13: "",
        pldt14: "",
        pldt15: 1,
        pldt16: "",
        pldt17: "",
        pldt18: "",
        pldt19: "",
        pldt20: new Date(),
        pldt21: localStorage.id,
        // 父节点ID
        pldt22: 0,
        pid: item.id,
        pldt23: "",
        time: [],
        type: "new",
        isPClear: isPClear,
      });
      this.addPldt01++;
      this.tierNum = 0;
      this.DomList = JSON.parse(JSON.stringify(this.DomList));
    },
    // 判断是多少级
    getTierNum(item) {
      if (item.pid == 0) {
        this.tierNum++;
      } else {
        this.tierNum++;
        let newArr = this.DomList.find((ele) => ele.id == item.pid);
        if (newArr) {
          this.getTierNum(newArr);
        }
      }
    },
    // 删除节点{}-
    deleteDom(index, item) {
      // find只能取第一个，这里我们需要用filter
      let newObj = this.DomList.filter((ele) => ele.pid == item.id);
      if (newObj) {
        this.DomList.splice(index, 1);
        newObj.forEach((ele) => {
          let newIndex = this.DomList.findIndex((ele2) => ele2.id == ele.id);
          this.deleteDom(newIndex, ele);
        });
      } else {
        this.DomList.splice(index, 1);
      }
      this.jsZB(item);
    },

    showAll() {
      this.fid = "null";
      this.bb();
    },
    handleBefore2(file) {
      let fd = new FormData();
      this.aaa.type = this.radio;
      let userID = [];
      this.multipleSelection3.forEach((ele) => {
        userID.push(ele.user01);
      });
      this.aaa.Uids = userID.join(",");
      fd.append("file", file);
      fd.append("model", this.aaa);
    },
    handleSuccess2(response, file, fileList) {
      if (response.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.dialogVisible = false;
        this.bb();
      }
    },
    dialogVisible1OPen() {
      this.dialogVisible1 = true;
      let params = {
        searchword: this.selectName,
        fid: 0,
        xid: localStorage.getItem("xid"),
      };
      GetFileWhitOutUserList({ params }).then((res) => {
        this.tableData3 = res.Data.list;
      });
    },
    handleSelectionChange3(val) {
      this.multipleSelection3 = val;
    },
    submitUpload2() {
      this.$refs.upload2.submit();
    },
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pftr02",
          },
          simpleData: {
            enable: true,
            idKey: "pftr01",
            pIdKey: "pftr03",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
          onRightClick: OnRightClick,
        },
      };
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          _this.aaa.gid = treeNode.pftr01;
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "dataListRemenu" ||
            $(event.target).parents("#dataListRemenu").length > 0
          )
        ) {
          $("#dataListRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type != "root") {
          $("#dataListRemenu").show();
          $("#addDataList").show();
          $("#dataListRemenu").css({
            top: y + "px",
            left: x + "px",
            visibility: "visible",
          }); //设置右键菜单的位置、可见
          $("body").bind("mousedown", onBodyMouseDown);
        }
      }

      $("#dataListRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#dataListRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addDataList") {
            _this.dialogVisible = true;
          }
        });

      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.TreeData
      );
      this.zTeeObj.checkAllNodes(true);

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.fid = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.fid += _split + element.pftr01;
        _split = ",";
      });
      _this.bb();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.fid = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.fid += _split + element.pftr01;
          _split = ",";
        });
        _this.bb();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.fid = treeNode.pftr01;
        _this.bb();
      }
    },

    async documentOpen(item) {
      this.documentIsShow = true;
      if (
        item.ext == "pdf" ||
        item.ext == "png" ||
        item.ext == "jpg" ||
        item.ext == "mp4" ||
        item.ext == "gif" ||
        item.ext == "txt"
      ) {
        this.iframeUrl = this.$store.state.baseUrl + item.prfl04;
      } else {
        let res = await Office2Pdf({ sourcePath: item.prfl04 });
        if (res.Code === 0) {
          this.$message({
            type: "warning",
            message: res.Message,
          });
        } else {
          this.iframeUrl = this.$store.state.baseUrl + res.Data;
        }
      }
    },
    //下载
    download(data) {
      tools.download(data.prfl07, data.prfl02);
    },
    showModel() {
      var _this = this;
      var config = {
        extensions: ["Autodesk.Viewing.ZoomWindow"],
        disabledExtensions: {
          measure: false,
          section: false,
        },
        memory: {
          limit: 32 * 1024, //32 GB
        },
        theme: "light-theme",
      };

      var element = document.getElementById("modelShow");
      _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(element, config);
      var options = {
        env: "Local",
        offline: "true",
        useADP: false,
      };

      const modelOpts = {
        applyRefPoint: true,
        globalOffset: {
          x: 0,
          y: 0,
          z: 0,
        },
      };

      Autodesk.Viewing.Initializer(options, function () {
        _this.viewer.start();
        _this.modelUrl.forEach((url) => {
          _this.viewer.loadModel(url, modelOpts);
        });
        let i = 0;
        _this.viewer.addEventListener(
          Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
          function () {
            i++;
            if (i == _this.modelUrl.length) {
              i = 0;
              _this.$message({
                type: "success",
                message: "模型加载完成",
              });
            }
          }
        );
      });
    },
    modelClose() {
      this.viewer.tearDown();
      this.orientationIsShow = false;
    },
    modelView(row) {
      this.viewer.impl
        .modelQueue()
        .getModels()
        .forEach((model) => {
          this.viewer.hide([model.getRootId()], model);
          if (model.loader.svfUrn.indexOf(row.url) > 0) {
            this.viewer.show(row.mosl05.split(",").map(Number), model);
          }
        });
    },
    // 定位
    async orientation(row) {
      this.orientationIsShow = true;
      let params = {
        modelId: this.modelId,
      };
      const res = await GetModelInfos(params);
      res.Data.forEach((v) => {
        this.modelUrl.push(this.$store.state.baseUrl + v.mode09);
      });
      this.showModel();
      this.pldt01 = row.pldt01;
      this.QhGanttChartShow = false;
      this.orientation2();
    },
    async orientation2() {
      let params = {
        id: this.pldt01,
      };
      const res = await GetPlanDetailOne(params);
      this.modelSelectList = res.Data.selectList;
    },
    submitUpload() {
      if (this.fileList.length > 0) {
        this.$refs.upload.submit();
      } else {
        this.$message({
          type: "warning",
          message: "请选择文件后上传",
        });
      }
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    beforeUpload(file) {
      let fd = new FormData();
      fd.append("file", file);
      fd.append("nodeFileData", this.nodeFileData);
      var index = file.name.lastIndexOf(".");
      var suffix = file.name.substring(index + 1);
      const extension = suffix === "xlsx";
      //(suffix);
      if (!extension) {
        this.$message({
          message: "上传文件只能是 xlsx格式!",
          type: "warning",
        });
        this.loading2 = false;
      }
      return extension;
    },
    // 上传成功
    uploadSuccess(data) {
      this.loading2 = false;
      this.updataModel1 = false;
      if (data.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.batchAddFile = false;
        this.dialogVisibleDom = false;
        this.GetPlanDetailTree();
      } else {
        this.$message({
          type: "warning",
          message: data.Message,
        });
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    uploadError() {
      this.loading2 = false;
    },

    batchAddDom() {
      this.batchAddFile = true;
    },
    GetRecordList(row) {
      this.planjindu = true;
      let params = {
        id: row.pldt01,
      };
      GetRecordList(params).then((res) => {
        this.jinduplanList = res.Data;
      });
    },
    // 切换甘特图
    QhGanttChart() {
      this.QhGanttChartShow = !this.QhGanttChartShow;
      this.orientationIsShow = false;
      this.openGanttChart();
    },
    // 初始化甘特图
    openGanttChart() {
      $(".gantt").gantt({
        dow: ["一", "二", "三", "四", "五", "六", "天"],
        months: [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月",
        ],
        source: this.GanttChartData2,
        waitText: "加载中，请等候",
        navigate: "scroll",
        scale: "days",
        maxScale: "months",
        minScale: "days",
        itemsPerPage: 20,
        cookieKey: "jquery.fn.gantt",

        onItemClick: function (data) {
          // 有数据范围内的点击事件
        },
        onAddClick: function (dt, rowId) {
          //无数据范围内的点击事件
        },
        onRender: function () {
          //渲染事件
          //
          if (window.console && typeof console.log === "function") {
            
          }
        },
      });
    },
    // 占时全部
    QhGanttChart2() {
      this.GanttChart = [
        { property: "State", label: "状态" },
        { property: "ExtensionDays", label: "延期天数" },
        { property: "CompletionSchedule", label: "完成进度" },
        { property: "PlanDays", label: "计划工期天数" },
        { property: "pldt05", label: "计划占比" },
        { property: "pldt06", label: "计划开始" },
        { property: "pldt07", label: "计划结束" },
        { property: "RealDays", label: "实际工期天数" },
        { property: "pldt08", label: "实际开始" },
        { property: "pldt09", label: "实际完成" },
        { property: "pldt10", label: "计划工程量" },
        { property: "pldt11", label: "实际工程量" },
        { property: "pldt23", label: "计量单位" },
        { property: "pldt12Name", label: "责任人" },
        { property: "pldt13Name", label: "相关人" },
      ];
    },
    AddRecord() {
      this.recordDetial = this.$refs.ck.ckeditor.getData();
      if (typeof this.Record != "number" || this.Record > 100) {
        this.$message({
          type: "error",
          message: "请检查进度",
        });
        return;
      }
      if (this.RecordTime == "") {
        this.$message({
          type: "error",
          message: "请输入时间",
        });
        return;
      }
      let params = {
        dtlk02: localStorage.xid,
        dtlk03: this.pldt01,
        dtlk08: this.Record,
        dtlk09: localStorage.id,
        dtlk10: this.RecordTime,
        dtlk07: this.recordDetial,
      };
      AddRecord(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "更改项目计划进度成功",
          });
        }
        this.addRecordIsShow = false;
        this.GetPlanDetailTree();
        this.GetRecordList({ pldt01: this.pldt01 });
        this.planjindu = false;
      });
    },
    delectModelSelect(row) {
      let params = {
        id: row.afli01,
      };
      DelPlanSelectOrDocument(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.GetPlanDetailOne();
        }
      });
    },
    delectModelSelect2(row) {
      let params = {
        id: row.afli01,
      };
      DelPlanSelectOrDocument(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.orientation2();
        }
      });
    },
    AddassociatedData() {
      //(this.GetFilesLinksList2);
      let DataIDList = [];
      this.GetFilesLinksList2.forEach((ele) => {
        DataIDList.push(ele.prfl01);
      });
      let params = [];
      DataIDList.forEach((ele) => {
        let params1 = {
          afli01: "",
          afli02: this.pldt01,
          afli03: ele,
          afli04: 4,
          afli05: 2,
        };
        params.push(params1);
      });
      AddPlanSelectOrDocument(params).then((res) => {
        //(res);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "添加文档成功",
          });
          this.GetPlanDetailOne();
          this.associatedData = false;
        }
      });
    },
    AddmodelChooseListOpen() {
      let DataIDList = [];
      this.multipleSelection.forEach((ele) => {
        DataIDList.push(ele.mosl01);
      });
      let params = [];
      DataIDList.forEach((ele) => {
        let params1 = {
          afli01: "",
          afli02: this.pldt01,
          afli03: ele,
          afli04: 4,
          afli05: 1,
        };
        params.push(params1);
      });
      AddPlanSelectOrDocument(params).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "添加模型选择集成功",
          });
          this.GetPlanDetailOne();
          this.modelChooseListOpen = false;
        }
      });
    },
    pushModelIds(type) {
      if (type == "model") {
        this.ruleForm.ModelSelectIds = [];
        this.GetModelSelectList2.forEach((ele) => {
          this.ruleForm.ModelSelectIds.push(ele.mosl01);
        });
      } else if (type == "file") {
        this.ruleForm.FileIds = [];
        this.GetFilesLinksList2.forEach((ele) => {
          this.ruleForm.FileIds.push(ele.prfl01);
        });
      }
    },
    unique(arr, type) {
      if (type == "model") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].mosl01 == arr[j].mosl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      } else if (type == "file") {
        for (var i = 0; i < arr.length; i++) {
          for (var j = i + 1; j < arr.length; j++) {
            if (arr[i].prfl01 == arr[j].prfl01) {
              //第一个等同于第二个，splice方法删除第二个
              arr.splice(j, 1);
              j--;
            }
          }
        }
      }
      return arr;
    },
    modelChooseListClose() {
      this.modelChooseListOpen = false;
      this.multipleSelection = [];
    },
    // 这里是切换模型
    handleClick(data) {
      //(data);
      this.mid = data;
      this.aa();
    },
    associatedDataClose() {
      this.associatedData = false;
      this.multipleSelection2 = [];
    },
    modelChooseList() {
      this.modelChooseListOpen = true;
      this.aa();
    },
    aa() {
      let params = {
        seachword: this.query2,
        mid: this.modelId,
      };
      GetModelSelect({ params }).then((res) => {
        this.GetModelSelectList = res.Data;
      });
    },
    deletemultipleSelection(data) {
      this.GetModelSelectList2.splice(data, 1);
      this.pushModelIds("model");
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
      this.GetFilesLinksList2.push(...val);
      this.GetFilesLinksList2 = this.unique(this.GetFilesLinksList2, "file");
      this.pushModelIds("file");
    },
    handleNodeClick(data) {
      this.fid = data.ID;
      this.bb();
    },
    deleteGetFilesLinksList2Item(data) {
      this.GetFilesLinksList2.splice(data, 1);
      this.pushModelIds("file");
    },
    associatedDataOpen() {
      this.associatedData = true;
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetProjectFileZTree({ params }).then((res) => {
        this.TreeData = res.Data;
        this.init();
      });
    },
    bb() {
      let params = {
        fid: this.fid,
        xid: localStorage.getItem("xid"),
        seachword: this.query3,
        uid: localStorage.getItem("id"),
      };
      GetFilesLinks({ params }).then((res) => {
        this.GetFilesLinksList = res.Data;
      });
    },
    // 修改按钮
    updataPlan() {
      this.form.pldt06 = this.form.pldt06N;
      this.form.pldt07 = this.form.pldt07N;
      this.form.pldt08 = this.form.pldt08N;
      this.form.pldt09 = this.form.pldt09N;
      this.form.pldt01 = this.pldt01;
      this.form.pldt02 = localStorage.xid;
      this.form.pldt15 == false
        ? (this.form.pldt15 = 0)
        : (this.form.pldt15 = 1);
      let params = this.form;
      //(this.form);
      UpdatePlanDetail({ model: params }).then((res) => {
        //(res);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.GetPlanDetailTree();
        }
      });
    },
    // 关闭及修改
    handleClose(done) {
      this.$confirm("还有未保存的工作哦确定关闭吗？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 查看
    seePlandrawer(row) {
      this.drawer = true;
      this.CompletionSchedule = row.CompletionSchedule;
      this.GetRecordList(row);
      this.planjindu = false;
      let params = {
        id: row.pldt01,
      };
      GetPlanDetailOne(params).then((res) => {
        this.form = res.Data;
        this.modelSelectList = res.Data.selectList;
        this.DataList = res.Data.docList;
      });
    },
    // 获取进度任务详情树
    GetPlanDetailTree() {
      let params = {
        planId: this.planid,
      };
      GetPlanDetailTree({ params }).then((res) => {
        this.bianLi(res.Data);
        this.tableData = res.Data;
        this.GanttChartData.forEach((ele) => {
          let myColor = "";
          let desc1 = "";
          if (ele.State == "未启动（延期）") {
            myColor = "ganttWqdYq";
            desc1 = "未启动（延期）";
          } else if (ele.State == "未启动") {
            myColor = "ganttWqd";
            desc1 = "未启动";
          } else if (ele.State == "计划") {
            myColor = "ganttJh";
            desc1 = "计划";
          } else if (ele.State == "执行中") {
            myColor = "ganttZxz";
            desc1 = "执行中";
          } else if (ele.State == "已完成（延期）") {
            myColor = "ganttYwcYq";
            desc1 = "已完成（延期）";
          } else if (ele.State == "已完成") {
            myColor = "ganttYwc";
            desc1 = "已完成";
          } else if (ele.State == "已完成（提前）") {
            myColor = "ganttYwcTq";
            desc1 = "已完成（提前）";
          } else if (ele.State == "执行中（延期）") {
            myColor = "ganttZxzYq";
            desc1 = "执行中（延期）";
          }

          this.GanttChartData2.push({
            name: ele.Name,
            desc:
              ele.CompletionSchedule == undefined
                ? ""
                : "完成度" + ele.CompletionSchedule + "%",
            values: [
              {
                from: ele.ks,
                to: ele.js,
                desc: desc1,
                label: ele.State == undefined ? "计划" : ele.State,
                customClass: ele.State == undefined ? "ganttJh" : myColor,
              },
            ],
          });
        });
      });
    },
    bianLi(data) {
      data.forEach((ele) => {
        let userids = [];
        userids = userids
          .concat(ele.pldt12 ? ele.pldt12.split(",") : [])
          .concat(ele.pldt13 ? ele.pldt13.split(",") : [])
          .concat([ele.pldt21])
          .map(Number);
        if (userids.includes(this.$store.state.uid)) {
          ele.isShow = true;
        }
        this.GanttChartData.push({
          ks: ele.pldt06,
          js: ele.pldt07,
          Name: ele.pldt04,
        });
        this.GanttChartData.push({
          ks: ele.pldt08 == null ? ele.pldt06 : ele.pldt08,
          js: ele.pldt09 == null ? new Date() : ele.pldt09,
          CompletionSchedule: ele.CompletionSchedule,
          Name: ele.pldt04,
          State: ele.State,
        });
        this.tableDataLocation.push(ele.pldt01);
        if (ele.children.length != 0) {
          this.bianLi(ele.children);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style lang="less">
#ProjectFileTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  line-height: 21px;
  margin-right: 2px;
}
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#dataListRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#dataListRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#dataListRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

.model {
  width: 45%;
  position: fixed;
  height: 50%;
  display: inline-flex;
}
.modelBottom {
  width: 45%;
  position: fixed;
  top: 70%;
  height: 20%;
  overflow-y: auto;
}
.constructionSchedule .search-input {
  width: 300px;
}
.constructionSchedule .el-table .warning-row {
  background: oldlace;
}

.constructionSchedule .el-table .success-row {
  background: #f0f9eb;
}
.PlanInfo {
  margin-bottom: 10px;
  font-size: 18px;
  font-family: "Franklin Gothic Medium", "Arial Narrow", Arial, sans-serif;
  margin: 10px;
  .el-form-item {
    margin-bottom: 5px;
  }
}
.el-drawer__open .el-drawer.rtl {
  overflow: auto;
}
.el-drawer__open .el-drawer.ltr {
  overflow: auto;
}
.constructionSchedule .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 85%;
}
.constructionSchedule .PlanInfo .el-input {
  width: 70%;
}
[data-v-e741f4b6] .el-dialog__body {
  padding-bottom: 20px;
}
.gantt_ot {
  width: 100% !important;
  margin: 0px !important;
}
.el-table--striped .el-table__body tr.el-table__row--striped.current-row td,
.el-table__body tr.current-row > td {
  background-color: oldlace !important;
}
.constructionSchedule .el-table .warning-index {
  background: skyblue;
}
</style>
